<template>
  <div class="info-box">
    <div class="flex-1 overflow-y-auto pr-2" id="printDom">
      <ul class="font-bold text-center text-gray-900 text-base">
        {{
          state.model?.meeting?.bill_title
        }}会议项目报账单
      </ul>
      <ul class="mt-5">
        尊敬的客户，恒路传媒会务非常荣幸协办本次
        <strong>“{{ state.model?.meeting?.name }}”</strong>
        会议；本次会议在贵司的大力支持下，已圆满结束。特将本次会议报账明细呈送给您审阅。如您对本账单有任何疑问，可随时拨打公司电话{{
          state.model?.meeting?.phone
        }}，或联系会务负责人{{
          state.model?.meeting?.belonger_name +
          state.model?.meeting?.belonger_phone
        }}！
      </ul>
      <c_cell title="会议名称" class="mt-5">
        <template #default>
          <strong>{{ state.model?.meeting?.name }}</strong>
        </template>
      </c_cell>
      <ul class="grid grid-cols-2 mt-3">
        <c_cell title="会议编号" :value="state.model?.meeting?.number" />
        <c_cell
          title="会议时间"
          :value="
            state.model?.meeting?.start_date +
            ' ~ ' +
            state.model?.meeting?.end_date
          "
        />
      </ul>
      <ul class="flex gap-x-5 mt-3">
        <c_cell title="会议负责人" :value="state.model?.meeting?.start_time" />
        <c_cell title="设计师" :value="state.model?.meeting?.start_time" />
        <c_cell title="车队调度员" :value="state.model?.meeting?.start_time" />
        <c_cell title="物料采购员" :value="state.model?.meeting?.start_time" />
      </ul>
      <c_cell
        title="摘要"
        class="!items-start mt-3 !w-full !grid"
        style="grid-template-columns: auto 1fr"
      >
        <template #default>
          <text v-if="props.id">{{ state.model.intro }}</text>
          <el-input
            v-else
            v-model="state.intro"
            type="textarea"
            class="w-full"
          />
        </template>
      </c_cell>
      <ul class="flex items-center mt-5 text-xs">
        账单成本明细合计：<c_money
          :value="state.model?.item_amount"
          :key="state.model?.item_amount"
          :prefix="false"
          bold
          :size="16"
        />
        <span class="w-10"></span>
        服务费按实际费用总额的{{
          state.model?.service_fee_rate
        }}%收取，共<c_money
          :value="state.model?.service_fee_amount"
          :key="state.model?.service_fee_amount"
          bold
          :prefix="false"
          :size="16"
        />元
        <span class="w-10"></span>
        税率{{
          state.model?.tax_fee_rate
        }}%合计税费<c_money
          :value="state.model?.tax_fee_amount"
          :key="state.model?.tax_fee_amount"
          bold
          :prefix="false"
          :size="16"
        />元，总计账单总金额：<c_money
          :value="state.model?.amount"
          :key="state.model?.amount"
          bold
          :prefix="false"
          :size="16"
        />元
        <span class="w-10"></span>
        明细如下：
      </ul>
      <el-table
        :data="state.model?.meetingBillItemList"
        v-loading="!Array.isArray(state.model?.meetingBillItemList)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        class="flex-1 mt-1"
        row-key="id"
        ref="tableDom"
        @selection-change="onSelectChange"
        @row-click="onRowClick"
      >
        <el-table-column
          label="类型"
          prop="d_cost_type_pname"
          :formatter="$tab_TextFormat"
          align="center"
        />
        <el-table-column
          label="分类"
          prop="d_cost_type_name"
          :formatter="$tab_TextFormat"
          align="center"
        />
        <el-table-column
          label="所属会场"
          prop="meetingPlace.name"
          :formatter="$tab_TextFormat"
          align="center"
        />
        <el-table-column
          label="采购项目"
          prop="name"
          :formatter="$tab_TextFormat"
          align="center"
        />
        <el-table-column
          label="规格"
          prop="specification"
          :formatter="$tab_TextFormat"
          align="center"
        />
        <el-table-column
          label="单价(元)"
          prop="price"
          :formatter="$tab_TextFormat"
          align="center"
        />
        <el-table-column
          label="数量"
          prop="count"
          :formatter="$tab_TextFormat"
          align="center"
        />
        <el-table-column
          label="天数"
          prop="day_count"
          :formatter="$tab_TextFormat"
          align="center"
        />
        <el-table-column
          label="合计金额"
          prop="amount"
          :formatter="$tab_TextFormat"
          align="center"
        />
        <el-table-column
          label="备注"
          prop="remark"
          :formatter="$tab_TextFormat"
          align="center"
        />
      </el-table>
    </div>
    <div class="submit-box px-2.5">
      <el-button
        v-if="props.id"
        plain
        :icon="Printer"
        @click="state.showPrint = true"
      >
        打印报账单
      </el-button>
      <el-button v-else type="primary" size="large" @click="onSubmit">
        确认生成
      </el-button>
    </div>
  </div>
  <el-dialog
    v-model="state.showPrint"
    title="打印会议账单"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showPrint = false;
      }
    "
    width="80%"
    style="height: 80%; max-height: 80%"
  >
    <c_print
      :meeting_id="props.meeting_id"
      :meeting_place_id="props.meeting_place_id"
      @close="
        () => {
          state.showPrint = false;
        }
      "
    />
  </el-dialog>
</template>

<script>
import { onMounted, reactive } from "vue";
import {
  meeting_bill_record_getAddData,
  meeting_bill_record_add,
  meeting_bill_record_detail,
} from "@/http/meeting";
import { ElMessage, ElMessageBox } from "element-plus";

import c_print from "./Print.vue";

export default {
  components: { c_print },
  props: {
    meeting_place_id: Number,
    id: Number,
  },
  setup(props, { emit }) {
    const printObj = {
      id: "printDom",
      beforeOpenCallback() {},
    };
    const state = reactive({
      model: {},
    });
    onMounted(() => {
      if (props.id) {
        meeting_bill_record_detail(props.id).then((res) => {
          if (res.status == 200) {
            state.model = res.data?.data || {};
          }
        });
      } else {
        meeting_bill_record_getAddData({
          meeting_bill_item_id: props.meeting_bill_item_id,
        }).then((res) => {
          if (res.status == 200) {
            state.model = res.data?.data || {};
          }
        });
      }
    });

    const onSubmit = () => {
      ElMessageBox.confirm(`您确定生成报账单吗`, "生成报账单", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        dangerouslyUseHTMLString: true,
        customClass: "c-delete-dialog",
        cancelButtonClass: "is-plain",
      }).then(() => {
        meeting_bill_record_add({
          meeting_bill_item_id: props.meeting_bill_item_id,
          intro: state.intro,
        }).then((res) => {
          if (res.status == 200) {
            ElMessage.success(res.data.msg);
            emit("confirm");
          } else {
            ElMessage.error(res.data.msg);
          }
        });
      });
    };

    return { state, props, onSubmit, printObj };
  },
};
</script>

<style lang="scss" scoped>
@media print {
  @page {
    size: auto;
    margin: 20px;
    page-break-before: always;
  }
  body * {
    visibility: hidden;
  }
  #printDom,
  #printDom * {
    visibility: visible;
  }
  #printDom {
    position: absolute;
    left: 0;
    top: 0;
  }

  #printDom::before {
    content: attr(data-title);
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 10px;
    display: block;
    text-align: center;
  }
}
</style>
